import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GasTableComponent } from '../gas-table/gas-table.component';
import { GasTable } from '../gas-table.namespace';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'tr [gasSelectableTableRow]',
  templateUrl: `./gas-selectable-table-row.component.html`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasSelectableTableRowComponent implements OnInit {

  @Input('gasSelectableTableRow')
  public value: GasTable.TableValue;

  public get isSelected(): boolean {
    return this.isSelectedSubject$.value;
  }

  public set isSelected(value: boolean) {
    this.isSelectedSubject$.next(value);
  }

  @Input()
  public disableRowSelectionFilter: ((rowData: Record<string, unknown>) => boolean) | undefined;

  public set isDisabled(value: boolean) {
    this.isDisabledSubject$.next(value);
  }

  public isSelected$: Observable<boolean>;
  public isDisabled$: Observable<boolean>;

  private isSelectedSubject$ = new BehaviorSubject<boolean>(false);
  private isDisabledSubject$ = new BehaviorSubject<boolean>(false);

  constructor(
    private gasTableComponent: GasTableComponent,
  ) {
    this.isSelected$ = this.isSelectedSubject$.asObservable();
    this.isDisabled$ = this.isDisabledSubject$.asObservable();
    this.gasTableComponent.tableService.selectionSource$
      .pipe(
        untilDestroyed(this),
      )
      .subscribe(() => {
        this.modifySelected();
      });
  }

  @HostBinding('class.gas-selectable-table-row')
  public isSelectableRow(): boolean {
    return this.gasTableComponent.selectionMode !== GasTable.TableRowsSelectionMode.None;
  }

  @HostBinding('class.gas-selectable-table-row__selected')
  public get isRowSelected(): boolean {
    return this.isSelected;
  }

  public get isSingleSelectionMode(): boolean {
    return this.gasTableComponent.selectionMode === GasTable.TableRowsSelectionMode.Single;
  }

  public get isMultipleSelectionMode(): boolean {
    return this.gasTableComponent.selectionMode === GasTable.TableRowsSelectionMode.Multiple
    ||  this.gasTableComponent.selectionMode === GasTable.TableRowsSelectionMode.OnlyBody;
  }

  public handleSelectRow(): void {
    if (this.isDisabledSubject$.value) {
      return;
    }
    this.gasTableComponent.selectRow(this.value);
  }

  public ngOnInit(): void {
    this.modifySelected();
  }

  private modifySelected(): void {
    if(this.disableRowSelectionFilter && this.disableRowSelectionFilter(this.value)) {
      this.isDisabled = true;
      return;
    }
    this.isDisabled = false;
    this.isSelected = this.gasTableComponent.isSelected(this.value);
  }
}
